"use client";

import { Button } from "@/components/ui/button";
import { StepCard } from "./StepCard";
import type { StepStatus, AccountBalances } from "./types";

interface Step7Props {
  status: StepStatus;
  isConnected: boolean;
  activeAccountId: string;
  balances: AccountBalances;
  onClaim: () => void;
  onGoBack?: () => void;
}

export function Step7ClaimRewards({
  status,
  isConnected,
  activeAccountId,
  balances,
  onClaim,
  onGoBack,
}: Step7Props) {
  const isProcessing = status === "in-progress";
  const hasAquaPosition = balances.lpAqua !== "0.00";

  return (
    <StepCard
      stepNumber={7}
      title="Claim Rewards"
      description="Harvest yield from Aqua pool rewards"
      status={status}
      onGoBack={onGoBack}
      completedSummary={<span>Reward claim attempted</span>}
    >
      <div className="space-y-4">
        <div className="bg-muted rounded-md p-3">
          <div className="text-sm font-medium mb-1">Aquarius Pool Rewards</div>
          <div className="text-xs text-muted-foreground">
            {hasAquaPosition
              ? `You have ${balances.lpAqua} Aqua LP shares earning rewards. Rewards accrue over time based on your share of the pool.`
              : "No active Aqua LP position. Deposit first to start earning rewards."}
          </div>
        </div>

        <div className="text-xs text-muted-foreground bg-muted rounded-md p-3">
          Only Aquarius pools have reward tokens. Soroswap pools earn fees directly via LP share appreciation.
          On testnet, rewards may not be configured or may take time to accrue.
        </div>

        <Button
          onClick={onClaim}
          disabled={!activeAccountId || !isConnected || isProcessing}
          variant="secondary"
          className="w-full"
        >
          {isProcessing ? "Claiming..." : "Claim Aqua Rewards"}
        </Button>
      </div>
    </StepCard>
  );
}
